// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"71840224","258":"01008bd5","279":"d563ab6b","296":"0674711f","463":"efad1480","790":"62f3d545","896":"1580c847"}[chunkId] + ".css";
};